export const UNIFIED_WITHDRAW_FORM_PT_BR = {
	drawerTitle: "Saque & Transferência",
	steps: {
		information: "Informações dos dados",
		review: "Revisão dos dados",
	},
	totalBalance: "Saldo Total",
	sendTo: "Enviar para",
	sendToPlaceholder: "Digite ou Selecione a conta",
	addNewAccount: "+ Adicionar nova Conta",
	addAccountDrawerTitle: "Nova conta",
	saveAccount: "Salvar conta",
	cancelAddAccount: "Cancelar",
	defaultAccountBadge: "Conta padrão",
	liquidValue: "Valor Líquido",
	liquidValuePlaceholder: "R$ 0,00",
	reason: "Motivo da Solicitação",
	reasonPlaceholder: "Digite o motivo para saque",
	goBack: "Voltar",
	goForward: "Avançar",
	submit: "Solicitar Saque",
	errorMessage: "Não foi possível processar sua solicitação. Tente novamente.",
	successMessage: "Sua solicitação de saque foi enviada com sucesso!",
	splitBar: {
		available: "Disponível",
		anticipation: "Antecipação",
	},
	totalChipGross: "Total com taxas",
	anticipationFee: "Taxa de antecipação",
	thirdPartyFee: "Taxa para conta de terceiro",
	valueAboveTotal: "Valor solicitado maior que valor total com taxas ({{value}})",
	feeError: {
		message: "Não foi possível consultar a taxa de antecipação. Tente novamente.",
		retry: "Tentar novamente",
	},
	review: {
		valuesReview: "Revisão dos Valores",
		typeLabel: "Tipo",
		typeWithdraw: "Saque",
		typeWithdrawAndAnticipation: "Saque + Antecipação",
		statusLabel: "Status",
		statusPending: "A processar",
		requestedValue: "Valor solicitado",
		walletValue: "Valor em carteira",
		anticipatedValue: "Valor antecipado",
		thirdPartyFeeLabel: "Taxa para conta de terceiro",
		anticipationFeeLabel: "Taxa de antecipação",
		grossValue: "Valor Bruto",
		netValueToAccount: "Valor líquido",
		amountToReceive: "Valor a receber",
		attentionBannerTitle: "Atenção",
		attentionBannerMessage:
			"Solicitações realizadas após as 10:30h (horário de Brasília) só serão atendidas no dia seguinte.",
		bankDataTitle: "Dados Bancários",
		holderLabel: "Titular da Conta",
		accountTypeLabel: "Tipo de Conta",
		agencyLabel: "Agência",
		accountNumberLabel: "Conta",
		pixKeyLabel: "Chave PIX",
	},
	completion: {
		title: "Tudo certo!",
		description:
			"O valor solicitado para saque está sendo processado pelo time Financeiro.",
	},
	partialFailure: {
		modalTitle: "Solicitação parcialmente processada",
		modalDescription:
			"Parte da sua solicitação foi processada, mas a outra parte não pôde ser concluída.",
		title: "Processamento incompleto",
		message:
			"Parte da operação foi concluída, mas a outra parte falhou. Verifique o extrato e tente novamente o que faltou.",
		notification:
			"Solicitação parcialmente processada — verifique o extrato e tente novamente o que faltou.",
	},
};

export type UnifiedWithdrawFormTranslations = typeof UNIFIED_WITHDRAW_FORM_PT_BR;
